import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import './css/jquery.circliful.css';
import './js/jquery.circliful';
import {setSpeedMeter,setGasMeter} from './js/MerterCircle';

class MeterCircle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }
    componentDidMount(){
        if(!this.props.small){
            if(this.props.ctype == 0){
                setSpeedMeter(this.props.cname,this.props.cvalue,this.props.vcolor);
            }
                
            else
                setGasMeter(this.props.cname,this.props.cvalue);
        }
    }
    componentDidUpdate(){
        
     
    }
    render() {
        const {t,ctype,cvalue,cname}=this.props;
        if(!this.props.small){
            if(this.props.ctype == 0)
                setSpeedMeter(this.props.cname,this.props.cvalue,this.props.vcolor);
            else
                setGasMeter(this.props.cname,this.props.cvalue);
        }
        
        return (
            this.props.small?
            <div className="meter-circle" style={{left:ctype==0 ? 0 : 80}}>
                {
                    ctype==0 ?
                    <div id={cname} style={{color:this.props.vcolor=="red"?"#ff0000":'#0e82f9',minWidth:70}}> 
                        <i class="fas fa-tachometer-alt"></i>
                        {" " + this.props.cvalue + " Km/hr."}
                    </div>
                    :
                    ctype==1 ?
                    <div id={cname} style={{color:this.props.vcolor=="red"?"#ff0000":'#0e82f9'}}> 
                        <i class="fas fa-gas-pump"></i>
                        {" " + this.props.cvalue + " %"}
                    </div>
                    :null
                }

            </div>
            :
            <div style={{paddingLeft:ctype==1?10:0}}>
                {
                    ctype==0 ?
                    <div id={cname} >
                    </div>
                    :
                    ctype==1 ?
                    <div id={cname}  >
                    </div>
                    :null
                }

            </div>
        )
    }
}
MeterCircle.defaultProps = {
    ctype: 0,
    cvalue: 0,
    cname: "no1"
}

MeterCircle.propTypes = {
	ctype: PropTypes.number,
    cvalue: PropTypes.number,
    cname: PropTypes.string
}
export default MeterCircle;


// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/MeterCircle/MeterCircle.js